module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "22px"
    },
    attrs: {
      "color": "grey",
      "small": ""
    }
  }, [_vm._v("group")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "persistent": true,
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.settings.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.adding = !_vm.adding
      }
    }
  }, [(_vm.adding) ? _c('v-icon', [_vm._v("list")]) : _c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), (_vm.adding) ? _c('div', {
    staticClass: "dialog-body pa-3"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Group Name",
      "hint": "Singular (not plural) eg Client"
    },
    model: {
      value: (_vm.group.name),
      callback: function($$v) {
        _vm.$set(_vm.group, "name", $$v)
      },
      expression: "group.name"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Can be a role in a transaction"
    },
    model: {
      value: (_vm.group.role),
      callback: function($$v) {
        _vm.$set(_vm.group, "role", $$v)
      },
      expression: "group.role"
    }
  })], 1) : _c('div', {
    staticClass: "dialog-body"
  }, [_c('v-list', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.groups), function(group, i) {
    return [_c('v-list-item', {
      class: {
        'blue-hilight': _vm.isSelected(group)
      },
      staticStyle: {
        "border": "solid 1px transparent"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select(group)
        }
      }
    }, [_c('v-list-item-avatar', [_c('img', {
      attrs: {
        "src": 'https://placeimg.com/40/40/people/' + i
      }
    })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                        " + _vm._s(group.name) + "\n                    ")]), _vm._v(" "), (group.role) ? _c('v-list-item-subtitle', [_c('Flag', {
      attrs: {
        "value": "Role"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-menu', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
              }
            }
          }, on), [_c('v-icon', {
            attrs: {
              "color": "grey darken-1"
            }
          }, [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.deleteGroup(group)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete group")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider')]
  }), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.adding = !_vm.adding
      }
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "grey--text text--lighten-2",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add_circle")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add Group")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("No results. Add a new one?")])], 1)], 1)], 2)], 1), _vm._v(" "), (_vm.adding) ? _c('div', {
    staticClass: "dialog-footer"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "disabled": !_vm.group.name
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveAndSelect($event)
      }
    }
  }, [_vm._v("Save and Select")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog($event)
      }
    }
  }, [_vm._v("Cancel")])], 1) : _c('div', {
    staticClass: "dialog-footer"
  }, [(_vm.settings.multiselect) ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.done($event)
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38e41c22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/GroupSelector.vue
// module id = 2507
// module chunks = 1